import { createContext } from 'react';
import { PreparedPaymentCustomer } from './PaymentSubmissionContext';

export interface CompletedKycDetails {
  fieldName: string;
  leadId: string;
}

export type KycFieldStatus = 'idle' | 'processing' | 'done' | 'error';

export interface KycFieldStatusState {
  status: KycFieldStatus;
  errorMessage: string;
}

export const KycSubmissionContext = createContext<
  {
    prepareLead: () => Promise<PreparedPaymentCustomer>;
    completeKyc: (
      fieldName: string,
      kyc: CompletedKycDetails,
    ) => Promise<void>;
    getKycStatus: (
      fieldName: string,
    ) => KycFieldStatusState | undefined;
    setKycStatus: (
      fieldName: string,
      state: KycFieldStatusState,
    ) => void;
    getFieldValue: (keywords: string[]) => string | undefined;
  } | null
>(null);
